<mat-toolbar color="primary">

  <mat-toolbar-row>
    <button mat-flat-button color="primary" [routerLink]="['']">
      <a><img src='../../../assets/angular-white-transparent.svg' width="35px" height="35px" alt="Italian Trulli"></a> {{title}}</button>
    <button style="margin: 5%;" mat-raised-button color="primary" [routerLink]="['home']">Home</button>
    <button mat-raised-button color="primary" [routerLink]="['contact']">Contact</button>
    <span class="example-spacer"></span>
    <mat-icon class="example-icon" aria-hidden="false" aria-label="Example user verified icon">http</mat-icon>
  </mat-toolbar-row>
</mat-toolbar>
